import React from 'react'
// Redux
import { Provider } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import { store } from './store'
import Router from './router'
import TermsOfUseScreen from './containers/termsOfUseScreen'

class App extends React.Component {
    constructor() {
        super();
        this.persistor = persistStore(store);

    }

    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={this.persistor}>
                <BrowserRouter>
                    <Router/>
                    <Route path="/" component={TermsOfUseScreen} />
                </BrowserRouter>
                </PersistGate>
            </Provider>
        )
    }
}

export default App;
